import { trace } from 'rytm-helpers'
import MMap from './MMap'

const maps = []


const initMap = (el, index) => {
  const id = el.id
  const dataSelector = el.dataset.mapData
  const $mapData = dataSelector ? $(dataSelector) : null
  if (!id || !$mapData) {
    trace("map init failed", el)
    return false
  }
  maps.push(new MMap(el, {id, $mapData}))
}


export const initMaps = () => {
  const list = [...document.querySelectorAll(".m-map")]
  list.forEach(initMap)
  return maps
}